module.exports = __webpack_public_path__ + "img/langtoucun.1e6bfb41.png";